import { Container, Grid, Paper } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import Card from "../components/Card";
import ProgressBar from '../components/ProgressBar';
import Titulo from "../components/Titulo";
import DashboardDetailsTheme from "./dashboard-details.styles";
import ModalClients from "../components/ModalClients";
import env from '../services/env';
  

const DashboardDetails = (props) => {
  const classes = DashboardDetailsTheme();

  // estado para armazenar chamada do modal de detalhes dos clientes
  const [open, setOpen] = useState(false);

  // estado para armazenar qual tabela será exibida ao clicar em detalhes no card.
  const [tabelaAtual, setTabelaAtual] = useState([]);
  const [rows, setRows] = useState([]);

  // estado para armazenar o nome da tabela a ser apresentada
  const [title, setNomeTabela] = useState("");

  const [clientsWithErrors, setClientsWithErrors] = useState([]);

  const allClients = props.clientes;

  const implantationStatus = {
    '1': 'Pendente',
    '2': 'Resolvido',
    '3': 'Ignorado'
  }

  // Const para organização da exibição das colunas na planilha gerada no front.
  const getRows = () => {
    return tabelaAtual.map((item) => {
      if (item.status) {
        return {
          id: item.crm,
          status: implantationStatus[item.status],
          createdAt: new Date(item.created_at),
          database: item.databases
            ? item.databases.join(', ')
            : "Sem registro",
          machine: item.machine ? item.machine : "Sem Registro",
        };
      }
      return {
        id: item.client.crm,
        status: item.statusBackup ? "Sucesso" : "Falha",
        data: new Date(item.lastBackupSucess),
        dataBackupSucesso: item.lastBackupSucess
          ? new Date(item.lastBackupSucess).toLocaleString()
          : "Sem registro",
        motivoFalha: (item.statusBackup && item.codeError) ? item.codeError.toUpperCase() : "Sem motivo",
      };
    });
  }

  const handleOpen = () => { setOpen(true) };
  const handleClose = () => { setOpen(false) };
  
  const [cards, setCards] = useState([]);
  const [erros, setErrors] = useState([]);

  const errorsPalete = [
    '#29A346',
    '#30F05D',
    '#F05A25',
    '#086EA3',
    '#18A6F0',
    '#FE6C6C',
    '#FEBD38'
  ];

  const cardAllClients = () => {
    return {
      id: 0,
      value: allClients.length,
      cor: '#25D9C3',
      abrirModal: handleOpen,
      setNomeTabela: setNomeTabela,
      setTabelaAtual: setTabelaAtual,
      tabela: allClients,
      texto: 'Clientes Ativos',
    }
  };

  const cardClientsWithError = () => {
    const filtered = allClients.filter((c) => c.errorDetail);
    return {
      id: 2,
      value: filtered.length,
      cor: '#FE6C6C',
      abrirModal: handleOpen,
      setNomeTabela: setNomeTabela,
      setTabelaAtual: setTabelaAtual,
      tabela: filtered,
      texto: 'Clientes com Erros',
    }
  };

  const cardClientsMoreThanDaysWithoudBackup = () => {
    const days = env('REACT_APP_DAYS_WITHOUT_BACKUPS') || 8;
    const today = new Date();
    const lastDays = today.setDate(today.getDate() - days);
    const filtered = allClients.filter((c) => Date.parse(c.lastBackupSucess) <= lastDays);
    return {
      id: 3,
      value: filtered.length,
      cor: '#FEBD38',
      abrirModal: handleOpen,
      setNomeTabela: setNomeTabela,
      setTabelaAtual: setTabelaAtual,
      tabela: filtered,
      texto: `Clientes sem backup há ${days} dias`,
    }
  };

  const cardImplantationPending = () => {
    setTabelaAtual(props.implantations || []);
    return {
      id: 4,
      value: props.implantations.length,
      cor: '#999',
      abrirModal: handleOpen,
      setNomeTabela,
      setTabelaAtual,
      tabela: props.implantations,
      texto: 'Clientes com implantação pendente',
    }
  };

  const populateCards = () => {
    setCards([
      cardAllClients(),
      cardClientsWithError(),
      cardClientsMoreThanDaysWithoudBackup(),
      cardImplantationPending(),
    ]);
  };

  const populateTypeErrors = () => {
    const clientsWithError = allClients.filter((client) => client.errorDetail);
    setClientsWithErrors(clientsWithError);

    const typeErrors = [];
    clientsWithError.forEach(c => {
      const errorExists = typeErrors.find((err) => err.code === c.codeError);
      if (!errorExists) {
        typeErrors.push({  
          id: parseInt(c.codeError),
          code: c.codeError,
          texto: c.errorDetail.description,
          cor: errorsPalete[Math.floor(Math.random() * errorsPalete.length)],
        })
      }
    });

    typeErrors.forEach(el => {
      el.tabela = allClients.filter((bkp) => bkp.codeError === el.code);
      el.setTabelaAtual = setTabelaAtual;
      el.abrirModal = handleOpen;
      el.exibeModal = true;
      el.title = title;
      el.setNomeTabela = setNomeTabela;
    });
    typeErrors.sort((a, b) => { return b.tabela.length - a.tabela.length });
    setErrors(typeErrors);
  };
  
  useEffect(() => {
    populateTypeErrors();
    populateCards();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ allClients, props.implantations]);

  useEffect(() => {
    setRows(getRows());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabelaAtual]);

  return (
    <div className={classes.main}>
      <ModalClients open={open} handleClose={handleClose} title={title} clients={tabelaAtual} rows={rows}/>

      <Titulo alignItems="center" />

      {/* Exibição dos cards e gráficos na tela */}
      <Container>
        <Grid container spacing={3} style={{marginTop: '1%'}}>
          {
            Object.keys(cards)
              .map(key => {
                if (cards[key].value > 0) {
                  return <Grid key={key} item xs={6} sm={3}><Card options={cards[key]} /></Grid>
                } else return null;
              })
          }
        </Grid>
        {
        (clientsWithErrors.length > 0) ? 
          <Grid container item={true} xs={12} className={classes.gridProgressBar}>
            <Paper className={classes.progressBarContainer}>
                <h2 className={classes.h2}>Erros:</h2>
                {
                  Object.keys(erros)
                    .map(key => {
                      return <ProgressBar key={key} options={erros[key]} total={clientsWithErrors.length}/>
                    })
                }
              </Paper>
          </Grid> 
          :
          <div className={classes.noErrorContainer} ><p className={classes.noErrorText}>Tudo certo por aqui ;)</p></div>}
      </Container>
    </div>
  );
};

export default DashboardDetails;
